import React, { useState, useEffect } from 'react';
import { errorMsg, homeUrl, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import {NavbarTop} from '../ui_components/navbar_top';

function QuestionNotes() {
  const [notesList, setNotesList] = useState([]);
  console.log("going to show all question notes table : ")

useEffect(() => {
  var NL = "<br> &nbsp; &nbsp; &nbsp; &nbsp; "
    var notes=[
        "You DON'T need to write any testing code or main method.",

       "You ONLY have to complete methods inside class Solution in Java or Python.",

       "As of now only Java till Java-11 and Python-3 are supported,"+
       NL+" other languages like C++, JavaScript are not supported.",

        "For question 1 to 11, use helper.print('') and helper.println('') for logging instead of "+
        NL+"  System.out.println() or println() else your logs won't be visible."+
        NL+" For other questions, System.out.println() or println() will work just fine.",

        "Any other class outside class Solution must be non public",

        "Put all import statements at the top, above class Solution"+
        NL+" and above all interface declaration, else it will give compiler error",

        "Class Solution constructor must always be public, "+
        NL+"  don't remove the public keyword",

        "If you are creating new interfaces, then they have to be declared on the top, "+
        NL+" even before class Solution, else it will give class not found error",

        "When init() method is called, then initialize and reset "+
        NL+" all of your instance variables and system state.",
    ];
    setNotesList(notes);  
}, []); // empty bracket means there are no dependencies which will make useEffect re run
// Talk is cheap, show me the code
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-slate-50">
      <NavbarTop />

      <main className="mx-auto flex w-full max-w-5xl justify-center px-4 pt-24 pb-12 sm:px-6 lg:px-8">
        {notesList.length > 0 && (
          <section className="w-full overflow-hidden rounded-3xl border border-orange-100 bg-white shadow-xl shadow-orange-100/60">
            <div className="border-b border-orange-100 bg-gradient-to-r from-orange-50 via-white to-indigo-50 px-5 py-7 text-center sm:px-8">
              <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-100 text-2xl shadow-sm">
                📝
              </div>

              <h1 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
                Notes
              </h1>

              <p className="mt-2 text-sm font-medium text-gray-500 sm:text-base">
                Important rules to follow before submitting your solution
              </p>
            </div>

            <table className="w-full table-auto border-collapse">
              <tbody className="divide-y divide-gray-100">
                {notesList.map((row, index) => (
                  <tr
                    key={index + 1}
                    className="group transition duration-200 hover:bg-orange-50/60"
                  >
                    <td className="px-4 py-4 sm:px-8 sm:py-5">
                      <div className="flex items-start gap-4">
                        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-gray-700 transition duration-200 group-hover:bg-orange-100 group-hover:text-orange-700">
                          {index + 1}
                        </span>

                        <span
                          className="prose max-w-none text-base font-medium leading-7 text-gray-800 sm:text-lg"
                          dangerouslySetInnerHTML={{ __html: row }}
                        >
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )}
      </main>
    </div>
  );
        
}

function QuestionNotesLink(){
    return (
    <span>
        <a href="../questionnotes/" target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 rounded-full border border-blue-100 bg-blue-50 px-4 py-2 text-sm font-bold text-blue-700 no-underline shadow-sm transition duration-200 hover:border-blue-200 hover:bg-blue-100 hover:text-blue-800 hover:shadow-md" >
        <span>Important Notes</span>
            </a>
    </span>      
    );      
}

export  {QuestionNotes, QuestionNotesLink};